/**
 * useRegisterPush — registers the device for push notifications and upserts
 * the token into public.device_tokens. Safe no-op on web.
 */
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { getPlatform, isNativePlatform } from "./platform";

export function useRegisterPush(userId: string | null | undefined) {
  useEffect(() => {
    if (!userId || !isNativePlatform()) return;
    let cancelled = false;

    (async () => {
      try {
        const { PushNotifications } = await import("@capacitor/push-notifications");

        const perm = await PushNotifications.checkPermissions();
        if (perm.receive !== "granted") {
          const req = await PushNotifications.requestPermissions();
          if (req.receive !== "granted") return;
        }

        await PushNotifications.register();

        await PushNotifications.addListener("registration", async (token) => {
          if (cancelled) return;
          await supabase.from("device_tokens").upsert(
            {
              user_id: userId,
              token: token.value,
              platform: getPlatform(),
              enabled: true,
              last_seen_at: new Date().toISOString(),
            },
            { onConflict: "user_id,token" },
          );
        });

        await PushNotifications.addListener("registrationError", (err) => {
          console.warn("[push] registration error", err);
        });
      } catch (e) {
        console.warn("[push] init failed", e);
      }
    })();

    return () => { cancelled = true; };
  }, [userId]);
}
